module.exports = __webpack_public_path__ + "static/img/img-empty-icon.f6073102.png";